<template>
  <v-application-view title="Employees">
    <v-layout row class="mx-2">
      <v-flex class="px-2 pt-2" md6>
        <v-card tile outlined>
          <v-data-table v-bind:headers="headers" v-bind:items="items" v-on:click:row="open">
            <template v-slot:item.name={item}>
              <v-list-item class="px-0">
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{item.first_name}} {{item.last_name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application-view>
</template>
<script>
export default {
  name: 'Employees',
  data: () => ({
    headers: [
      {text: 'Employee', value: 'name'},
      {text: 'Role', value: 'role'}
    ],
    items: [
      {id: 1, first_name: 'Firdavs', last_name: 'Beknazarov', role: 'owner'},
      {id: 2, first_name: 'Ruslan', last_name: 'Roupov', role: 'manager'},
      {id: 3, first_name: 'Shaxlo', last_name: 'Alimova', role: 'cashier'},
    ]
  }),
  methods: {
    open(item){
      this.$router.push({name: 'employee', params: {
        id: item.id
      }, query: {
        back: this.$route.name
      }})
    }
  }
}
</script>
